const languageCurrencyMap: Record<General.SystemLanguage, General.Currency> = {
  'zh-CN': 'CNY',
  'en-US': 'USD',
  id: 'IDR',
  th: 'THB',
  tl: 'USD',
  es: 'MXN',
  vi: 'USD',
  pt: 'USD',
};

export default languageCurrencyMap;
